import Badge from 'antd/lib/badge';
import Collapse from 'antd/lib/collapse';
import Space from 'antd/lib/space';
import Typography from 'antd/lib/typography';
import * as React from 'react';
import { iconAndAltForIntegrationType } from '../../helpers/integrationHelpers';
import { IntegrationType } from '../../types';
import { antGrey, appHomeCardsWidgetTitleStyle } from '../styles/globalStyles';
import { CaretRightOutlined } from '@ant-design/icons';

export interface CollapsibleSectionProps {
    title: string;
    badge?: number;
    shouldHaveWhiteBackground?: boolean;
    integrationType?: IntegrationType;
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
    title,
    children,
    integrationType,
    badge,
    shouldHaveWhiteBackground,
}) => {
    const [icon, alt] = iconAndAltForIntegrationType(integrationType);
    return (
        <Collapse
            bordered={false}
            expandIcon={({ isActive }) => (
                <CaretRightOutlined
                    style={{
                        color: antGrey.grey6,
                        fontSize: 18,
                    }}
                    rotate={isActive ? 90 : 0}
                />
            )}
            className={
                shouldHaveWhiteBackground ?
                    'collapsible-monitoring-section-white'
                :   'collapsible-monitoring-section-gray'
            }
        >
            <Collapse.Panel
                key="1"
                header={
                    <Space size={12} align="baseline">
                        {icon && <img src={icon} alt={alt} style={{ width: 18, height: 18 }} />}
                        <Typography.Text style={{ ...appHomeCardsWidgetTitleStyle }}>{title}</Typography.Text>
                        {!!badge && <Badge count={badge} style={{ backgroundColor: antGrey.grey6 }} />}
                    </Space>
                }
            >
                {children}
            </Collapse.Panel>
        </Collapse>
    );
};
